export const advisorRoutes = {
  advisorDashboardInfo: 'advisor/dashboard/getInfo',
  requestMeeting: 'advisor/manage/requestMeeting/',
  studentProgress: 'advisor/manage/progress/',
  getStudentSchedules: 'advisor/manage/getStudentSchedules/',
  getStudentSchedulesDigest: 'advisor/manage/getStudentSchedulesDigest/',
  getStudentSchedule: 'advisor/manage/getStudentSchedule/',
  addItemToSchedule: 'advisor/manage/addItemToSchedule/',
  updateScheduleItem: 'advisor/manage/updateScheduleItem/',
  setScheduleDesc: 'advisor/manage/setScheduleDesc/',
  removeItemFromSchedule: 'advisor/manage/removeItemFromSchedule/',
  removeSchedule: 'advisor/manage/removeSchedule/',
  notifyStudentForSchedule: 'advisor/manage/notifyStudentForSchedule/',
  getAdvisorTags: 'advisor/manage/getAdvisorTags/',
  addAdvisorTag: 'advisor/manage/addAdvisorTag/',
  removeAdvisorTag: 'advisor/manage/removeAdvisorTag/',
  copySchedule: 'advisor/manage/copy/',
  getStudentsDigest: 'advisor/manage/getStudentsDigest',
  getMyFinancePlans: 'advisor/manage/getOffers/',
  lessonsInSchedule: 'advisor/manage/lessonsInSchedule/',
  getStudentDigestForAdvisor: 'advisor/manage/getStudentDigest/',
  getMyCurrentRoomForAdvisorForSpecificStudent:
    'advisor/manage/getMyCurrentRoomForAdvisorForSpecificStudent/',
  createNewOffer: 'advisor/manage/createNewOffer/',
  updateOffer: 'advisor/manage/updateOffer/',
  removeOffers: 'advisor/manage/removeOffers',
  myStudentRequests: 'advisor/manage/myRequests',
  answerStudentRequest: 'advisor/manage/answerToRequest/',
  toggleStdAcceptance: 'advisor/manage/toggleStdAcceptance',
  removeStudentsByAdvisor: 'advisor/manage/removeStudents',

  // TEACH API's
  getTeachSchedules: 'teach/manage/getSchedules',
  getTeachSchedule: 'teach/manage/getSchedule/',
  createTeachSchedules: 'teach/manage/createNewSchedule',
  createTeachSchedulesPackage: 'teach/manage/createPackage',
  copyTeachSchedule: 'teach/manage/copySchedule/',
  removeTeachSchedule: 'teach/manage/removeSchedule/',
  setRequestStatus: 'teach/manage/setRequestStatus/',
  getTeachRequests: 'teach/manage/getRequests',
  updateTeachSchedule: 'teach/manage/updateSchedule/',
  updateTeachPackage: 'teach/manage/updatePackage/',
  getScheduleStudents: 'teach/manage/getScheduleStudents/',
  createMeetingRoomForTeach: 'teach/manage/createMeetingRoom/',
  getMyTeachTransactions: 'teach/manage/getMyTransactions',
  getMyTeachSettledRequests: 'teach/manage/getMySettledRequests',
  teachSettlementRequest: 'teach/manage/settlementRequest',
  cancelTeachSettlementRequest: 'teach/manage/cancelSettlementRequest',
  rateToTeachSchedulesStudent: 'teach/manage/rateToSchedule/',
  getMyTeachScheduleReportProblemsForTeacher:
    'teach/manage/getMyTeachScheduleReportProblems/',
  setMyTeachScheduleReportProblemsForTeacher:
    'teach/manage/setTeachScheduleReportProblems/',
  getAdvisorDashboardConfig: 'advisor/dashboard/getConfig',
  setAdvisorDashboardConfig: 'advisor/dashboard/setConfig',
};
